<template>
   <div class="asset-wrapper" :class="{active: active, hidden_zone: isHidden, locked: locked}" :style="getZIndex">
      <div class="zone-label" :style="getZoneLabelStyle">Zone {{zone.id/1000}} {{zone.name}}</div>
      <div id="color_asset" class="asset-shadow" :style="style">
         <div class="color-bg" :style="getColorStyle"></div>
      </div>
   </div>
</template>

<script>
import Zone from './Zone'

export default {
   extends: Zone,

   computed: {
      getColorStyle() {
         let bgColor = this.zone.style.backgroundColor;
         if (this.zone.style[this.currScene]) {
            this.zone.style[this.currScene].backgroundColor = bgColor;
            return this.zone.style[this.currScene];;
         } else {
            return ' background-color: ' + bgColor + ';';
         }
      }
   }
}
</script>

<style lang="scss">

.locked {
   .zone-label {
      display: none;
   }
}

#color_asset {
   position: absolute;

   .color-bg {
      width: 100%;
      height: 100%;
   }
}
</style>